import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './css/reset.css'
import './css/jquery.ui.core.css'
import './css/jquery.ui.theme.css'
import './css/jquery.ui.dialog.css'
import './css/mobile-responsive.css'
import { Outlet } from 'react-router-dom'
import FooterInner from './FooterInner.jsx';
import SideBar from './SideBar.jsx';
import HeaderInner from './HeaderInner.jsx';

function Innerlayout() {
   const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

   useEffect(() => {
      const linkId = 'innerlayout-main-css';
      if (!document.getElementById(linkId)) {
         const link = document.createElement('link');
         link.id = linkId;
         link.rel = 'stylesheet';
         link.href = `${process.env.PUBLIC_URL || ''}/css/user/main.css`;
         document.head.appendChild(link);
      }
      return () => {
         const el = document.getElementById(linkId);
         if (el) el.remove();
      };
   }, []);

   useEffect(() => {
      const closeSidebarOnDesktop = () => {
         if (window.innerWidth > 768) {
            setIsMobileSidebarOpen(false);
         }
      };
      window.addEventListener("resize", closeSidebarOnDesktop);
      return () => window.removeEventListener("resize", closeSidebarOnDesktop);
   }, []);

   useEffect(() => {
      if (!isMobileSidebarOpen) return;

      const handleOutsideInteraction = (event) => {
         if (window.innerWidth > 768) return;
         const target = event.target;
         if (!(target instanceof Element)) return;

         if (target.closest('#sidebar') || target.closest('#sidebarCollapse')) {
            return;
         }
         setIsMobileSidebarOpen(false);
      };

      document.addEventListener("click", handleOutsideInteraction);
      document.addEventListener("touchstart", handleOutsideInteraction);
      return () => {
         document.removeEventListener("click", handleOutsideInteraction);
         document.removeEventListener("touchstart", handleOutsideInteraction);
      };
   }, [isMobileSidebarOpen]);

   return (<>
      <div className="wrapper">
         <SideBar
            isMobileOpen={isMobileSidebarOpen}
            onNavigate={() => setIsMobileSidebarOpen(false)}
         />
         <div id="container">
            <nav className="navbar navbar-expand-lg col-sm-12">
               <HeaderInner onToggleSidebar={() => setIsMobileSidebarOpen((prev) => !prev)} />
            </nav>
            <Outlet />
            <FooterInner />            
         </div>
      </div >
   </>
   )
}
export default Innerlayout
